import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import EmptyResults from 'cityads-v3/components/EmptyResults/EmptyResults'

import Button from '@mui/material/Button'
import DoneIcon from '@mui/icons-material/Done'

type AddDomainSuccessProps = {
  onClose: () => void
}

const AddDomainSuccess: React.FC<AddDomainSuccessProps> = function AddDomainSuccess({ onClose }) {
  const { t } = useTranslation(['DomainParking', 'main']);
  return (
    <EmptyResults
      icon={<DoneIcon />}
      emptyText={
        <Trans t={t} i18nKey={'formSuccess'}>
          Domain is added to the queue, and its current status is in the parked
          <a
            href="/publisher/tools/domainParking"
            target="_blank"
            rel="nofollow noopener"
          >domains list</a>.
        </Trans>
      }
      actions={
        <Button
          color="primary"
          onClick={onClose}
          variant="contained"
        >{t('main:buttons.close')}</Button>
      }
    />
  )
}

export default AddDomainSuccess;
